import { render, staticRenderFns } from "./MsotAddEditMpot.vue?vue&type=template&id=1348ce4d&scoped=true&"
import script from "./MsotAddEditMpot.vue?vue&type=script&lang=js&"
export * from "./MsotAddEditMpot.vue?vue&type=script&lang=js&"
import style0 from "./MsotAddEditMpot.vue?vue&type=style&index=0&id=1348ce4d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1348ce4d",
  null
  
)

export default component.exports